<template>
  <a
    tabindex="0"
    href="#"
    :class="textClasses"
    @mouseover="mouseoverHandler"
    @mouseout="mouseoutHandler"
  >
    <slot name="suggestion" v-bind="{ data: data, htmlText: htmlText }">
      <span v-html="htmlText"></span>
    </slot>
  </a>
</template>

<script>
export default {
  name: 'VueBootstrapTypeaheadListItem',

  props: {
    data: {},
    activeSuggestion: {
      type: String,
    },
    htmlText: {
      type: String
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },

  computed: {
    active() {
      return this.data === this.activeSuggestion;
    },

    textClasses() {
      let classes = ''
      classes += this.active ? 'active' : ''
      classes += this.backgroundVariant ? ` bg-${this.backgroundVariant}` : ''
      classes += this.textVariant ? ` text-${this.textVariant}` : ''
      return `vbst-item list-group-item list-group-item-action ${classes}`
    }
  },

  methods: {
    mouseoverHandler() {
      this.$emit('mouse-over-suggestion', this.data);
    },

    mouseoutHandler() {
      this.$emit('mouse-out-suggestion', this.data);
    },
  }
}
</script>
